export default "__VITE_ASSET__90f51bcc__"